import { render } from "./NewsMalaysia.vue?vue&type=template&id=763ad35e&scoped=true"
const script = {}

import "./NewsMalaysia.vue?vue&type=style&index=0&id=763ad35e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763ad35e"]])

export default __exports__